import { styled } from '@mui/material';

/** the weekday in front of the date inside the field */
export const WeekdayAdornment = styled('span')(({ theme }) => ({
  color: theme.palette.text.secondary,
  marginRight: theme.spacing(0.5)
}));
